import typia from 'typia';

const isIdList = typia.createIs<string[]>();

/**
 * True the first time it is called for `id` under `storageKey` in this browser, and records it, so
 * an analytics event tied to that id is sent once however often its page is reached again. Keeps
 * the last `size` ids. When storage is blocked it answers true: counting an event twice is the
 * smaller loss than never counting it. localStorage directly, not StorageService: that one is
 * async, and the read and write must not let another tab in between.
 */
export function claimOnce(storageKey: string, id: string, size: number): boolean {
  try {
    const stored: unknown = JSON.parse(localStorage.getItem(storageKey) ?? '[]');
    const claimed = isIdList(stored) ? stored : [];
    if (claimed.includes(id)) {
      return false;
    }
    localStorage.setItem(storageKey, JSON.stringify([...claimed, id].slice(-size)));
  } catch {
    // Blocked, full, or not valid JSON: fall through and count it.
  }
  return true;
}
